module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a88b47b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/Main.vue
// module id = 2026
// module chunks = 18